/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_All_Free_ToolsInputs */

const en_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All free tools`)
};

const zh_hans1_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部免费工具`)
};

const pt_br2_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as ferramentas grátis`)
};

const es_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las herramientas gratis`)
};

const fr_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les outils gratuits`)
};

const de_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle kostenlosen Tools`)
};

const ru_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все бесплатные инструменты`)
};

const it_footer_all_free_tools = /** @type {(inputs: Footer_All_Free_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti gli strumenti gratuiti`)
};

/**
* | output |
* | --- |
* | "All free tools" |
*
* @param {Footer_All_Free_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_all_free_tools = /** @type {((inputs?: Footer_All_Free_ToolsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_All_Free_ToolsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_all_free_tools(inputs)
	if (locale === "pt-BR") return pt_br2_footer_all_free_tools(inputs)
	if (locale === "es") return es_footer_all_free_tools(inputs)
	if (locale === "fr") return fr_footer_all_free_tools(inputs)
	if (locale === "de") return de_footer_all_free_tools(inputs)
	if (locale === "ru") return ru_footer_all_free_tools(inputs)
	if (locale === "it") return it_footer_all_free_tools(inputs)
	return en_footer_all_free_tools(inputs)
});